<template>
  <div class="text-chip my-3" @click="emitToggle">
    <div class="flex flex-row justify-between mb-2 pl-5">
      <div>
        <vs-chip class="mr-4" color="dark">
          {{ mainPolicyNumber }}
        </vs-chip>

        <span class="purchase-type-label">
          {{ item.purchaseType.ticketType }}
        </span>

        <vs-chip v-if="item.checkout.isLoose" class="mr-4" color="primary">
          Avulso
        </vs-chip>

        <vs-chip
          v-if="item.status"
          class="mr-4"
          :color="getStatusColor(item.status)"
        >
          {{ getStatusLabel(item.status) }}
        </vs-chip>
      </div>
      <div class="purchase-header-actions">
        <vs-button
          v-if="
            permissionCreditCardRefundHistory &&
            hasCreditCardRefunds(item.creditCardRefunds)
          "
          radius
          color="primary"
          icon-pack="feather"
          icon="icon-list"
          v-tooltip="'Histórico de restituições'"
          @click.stop="$emit('open-refund-history', item.id)"
        ></vs-button>
        <vs-button
          v-if="
            permissionCreditCardRefund && refundedStatusPurchases(item.status)
          "
          color="warning"
          radius
          icon-pack="feather"
          icon="icon-dollar-sign"
          v-tooltip="'Fazer restituição'"
          @click.stop="$emit('open-refund', item.id)"
          class="ml-1"
          :class="{ 'mr-6': !showArrow }"
        ></vs-button>

        <vs-button
          v-if="permissionReviewAntiFraud && item.antiFraudConfigSnapshot"
          color="blue"
          radius
          icon-pack="feather"
          icon="icon-credit-card"
          v-tooltip="'Dados do antifraude'"
          @click.stop="$emit('open-anti-fraud', item)"
        ></vs-button>
        <vs-icon
          v-if="showArrow"
          icon-pack="feather"
          icon="icon-chevron-down"
          class="purchase-arrow-icon ml-3"
          :class="{ 'is-expanded': isExpanded }"
        ></vs-icon>
      </div>
    </div>
    <div class="purchase-header-row px-5">
      <CreditCardPurchaseSummaryCard :item="item" />
    </div>
  </div>
</template>

<script>
import CreditCardPurchaseSummaryCard from '@/components/installments/CreditCardPurchaseSummaryCard.vue';
import { PURCHASE_STATUS, STATUS_PURCHASE } from '@/utils/constants';

export default {
  name: 'CreditCardPurchaseHeader',
  components: {
    CreditCardPurchaseSummaryCard,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    mainPolicyNumber: {
      type: [String, Number],
      required: true,
    },
    permissionCreditCardRefundHistory: {
      type: Boolean,
      default: false,
    },
    permissionCreditCardRefund: {
      type: Boolean,
      default: false,
    },
    permissionReviewAntiFraud: {
      type: Boolean,
      default: false,
    },
    showArrow: {
      type: Boolean,
      default: false,
    },
    isExpanded: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    emitToggle() {
      if (!this.showArrow) return;
      this.$emit('toggle', this.item.id);
    },
    getStatusColor(status) {
      const warning = [PURCHASE_STATUS.GENERATED];
      const success = [
        PURCHASE_STATUS.AUTHORIZED,
        PURCHASE_STATUS.UNDERPAID,
        PURCHASE_STATUS.OVERPAID,
        PURCHASE_STATUS.PAID,
        PURCHASE_STATUS.CAPTURED,
      ];
      const danger = [
        undefined,
        '',
        PURCHASE_STATUS.PARTIALLY_CANCELED,
        PURCHASE_STATUS.CANCELED,
        PURCHASE_STATUS.DENIED,
      ];
      const dark = [
        PURCHASE_STATUS.WITH_ERROR,
        PURCHASE_STATUS.FAILED,
        PURCHASE_STATUS.NOTIFICATION_FAILED,
      ];
      const primary = [PURCHASE_STATUS.PROCESSING];

      if (warning.includes(status)) return 'warning';
      if (success.includes(status)) return 'success';
      if (danger.includes(status)) return 'danger';
      if (dark.includes(status)) return 'dark';
      if (primary.includes(status)) return 'primary';
    },
    getStatusLabel(status) {
      return STATUS_PURCHASE[status];
    },
    refundedStatusPurchases(status) {
      const refundedStatus = [
        PURCHASE_STATUS.PAID,
        PURCHASE_STATUS.PARTIALLY_CANCELED,
        PURCHASE_STATUS.CAPTURED,
      ];
      return refundedStatus.includes(status);
    },
    hasCreditCardRefunds(refunds) {
      if (!refunds || !Array.isArray(refunds)) return false;
      return refunds.length > 0;
    },
  },
};
</script>

<style scoped lang="scss">
.text-chip {
  font-size: 1.2rem;
}

.purchase-type-label {
  font-family: 'Montserrat', 'Segoe UI', sans-serif;
  font-size: 15px;
  line-height: 20px;
  color: #3e424d;
}

.purchase-header-row {
  display: block;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
}

.purchase-header-actions {
  display: inline-flex;
  align-items: center;
}

.purchase-arrow-icon {
  color: #666b75;
  font-size: 16px;
  line-height: 1;
  transition: transform 0.2s ease;
}

.purchase-arrow-icon.is-expanded {
  transform: rotate(180deg);
}
</style>
